module.exports = __webpack_public_path__ + "img/modal-document-confirm.f147d550.svg";